module.exports = __webpack_public_path__ + "media/video_12.f482294c.mp4";